export default {
  // Schemas
  async getSchemaByUri(schemaName) {
    return this.request(`/schemas/name/${encodeURIComponent(schemaName)}`);
  },

  async validateSchema(schemaId, data) {
    return this.request(`/schemas/${schemaId}/validate`, {
      method: 'POST',
      body: data,
    });
  },

  async getSchemaVersions(schemaName) {
    const response = await this.request(`/schemas/name/${encodeURIComponent(schemaName)}/versions`);
    return response.versions || [];
  },
};
